'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../providers/ClaimBuilder/index.js');
var Typography = require('../../../components/Typography.js');
var Divider = require('@narvar/nth-bit-divider');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var styled = require('styled-components');
var Currency = require('../../../components/Currency.js');
var SessionContext = require('../../../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ClaimAmountRow = styled__default["default"].div.withConfig({
  componentId: "sc-jd0xi8-0"
})(["display:flex;justify-content:space-between;margin-bottom:2rem;"]);
const ClaimSummaryEstimatedAmount = () => {
  const {
    state: {
      currency,
      claimAmount
    }
  } = index.useClaimBuilder();
  const {
    claimsSummaryClaimAmount
  } = nthHookTranslations.useTranslations();
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(ClaimAmountRow, null, /*#__PURE__*/React__default["default"].createElement(Typography.TertiaryHeader, {
    s: {
      textTransform: 'none'
    }
  }, claimsSummaryClaimAmount), /*#__PURE__*/React__default["default"].createElement(Typography.TertiaryHeader, {
    as: "p",
    s: {
      textTransform: 'none'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    value: claimAmount ?? 0,
    locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
    currency: currency
  }))));
};
var ClaimSummaryEstimatedAmount$1 = nthHookTranslations.withTranslationsProvider(ClaimSummaryEstimatedAmount, {
  translationKeys: ['claimsSummaryClaimAmount']
});

exports["default"] = ClaimSummaryEstimatedAmount$1;
